module.exports = __webpack_public_path__ + "images/file_icons_v2/psd-8252ccc7a6ab305ae7ac5fd56c6dc235.svg";